<template lang="pug">
.custom-export-field.panel.panel-default(style="margin-bottom: 10px; padding: 10px;")
  //- Display mode for saved fields
  template(v-if="!isNew && !editing")
    .display-row
      .field-content
        div
          strong Name: 
          span {{ name }}
        div
          strong Value: 
          span {{ value || '(empty)' }}
      .field-actions
        .btn-group
          button.btn.btn-sm.btn-default(type="button" @click="editing = true" title="Edit")
            i.fa.fa-pencil
          button.btn.btn-sm.btn-danger(type="button" @click="deleteField()" title="Delete")
            i.fa.fa-times
  
  //- Edit mode for saved fields or new fields
  template(v-else)
    .form-group(style="margin-bottom: 10px;")
      label Name
      input.form-control(
        v-model="name"
        @blur="parameterizeName"
        placeholder="field_name"
      )
    .form-group(style="margin-bottom: 10px;")
      label Value
      input.form-control(
        v-model="value"
        placeholder="Field value"
      )
    .btn-group
      button.btn.btn-success(type="button" @click="saveField()" :disabled="saving")
        i.fa(:class="saving ? 'fa-spinner fa-spin' : 'fa-save'")
        |  
        | {{ isNew ? 'Save' : 'Update' }}
      button.btn.btn-default(type="button" @click="cancelEdit()")
        i.fa.fa-times
        |  Cancel
</template>

<script>
  import { mapStores } from 'pinia'
  import { useStoryCustomFieldsStore } from '@/stores/story_custom_fields'

  export default {
    props: {
      storyCustomFieldId: {
        type: [Number, String],
        required: true
      }
    },

    data() {
      return {
        saving: false,
        editing: false,
        originalName: '',
        originalValue: ''
      }
    },

    computed: {
      ...mapStores(useStoryCustomFieldsStore),

      storyCustomField() {
        return this.storyCustomFieldsStore.byId(this.storyCustomFieldId)
      },

      isNew() {
        return this.storyCustomField?.isNew || false
      },

      name: {
        get() {
          return this.storyCustomField?.name || ''
        },
        set(val) {
          this.storyCustomFieldsStore.updateLocal(this.storyCustomFieldId, 'name', val)
        }
      },

      value: {
        get() {
          return this.storyCustomField?.value || ''
        },
        set(val) {
          this.storyCustomFieldsStore.updateLocal(this.storyCustomFieldId, 'value', val)
        }
      }
    },

    watch: {
      editing(newVal) {
        if (newVal) {
          // Store original values when entering edit mode
          this.originalName = this.name
          this.originalValue = this.value
        }
      }
    },

    methods: {
      parameterizeName() {
        // Auto-parameterize the name: lowercase, replace spaces/special chars with underscores
        let parameterized = this.name
          .toLowerCase()
          .replace(/[^a-z0-9_]/g, '_')
          .replace(/_+/g, '_')
          .replace(/^_/, '')
        
        // Ensure it starts with a letter
        if (parameterized && !/^[a-z]/.test(parameterized)) {
          parameterized = 'field_' + parameterized
        }
        
        this.name = parameterized
      },

      async saveField() {
        this.parameterizeName()
        this.saving = true
        try {
          await this.storyCustomFieldsStore.save(this.storyCustomFieldId)
          this.editing = false
        } finally {
          this.saving = false
        }
      },

      cancelEdit() {
        if (this.isNew) {
          // Remove unsaved field
          this.storyCustomFieldsStore.delete(this.storyCustomFieldId)
        } else {
          // Restore original values and exit edit mode
          this.name = this.originalName
          this.value = this.originalValue
          this.editing = false
        }
      },

      deleteField() {
        this.storyCustomFieldsStore.delete(this.storyCustomFieldId)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .custom-export-field {
    background-color: #f9f9f9;
    
    .display-row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      
      .field-content {
        flex: 1;
        min-width: 0;
      }
      
      .field-actions {
        flex-shrink: 0;
        margin-left: 10px;
      }
    }
    
    label {
      font-weight: 600;
      margin-bottom: 4px;
    }
    
    .btn-group {
      display: flex;
      
      .btn {
        flex: 1;
      }
    }
  }
</style>
